const reducerScheduledServices = {
  completed: 'Serviços Realizados',
  delayed: 'Serviços Atrasados',
  scheduledServices: 'Serviços Agendados',
};

export default reducerScheduledServices;
